<template>
  <div class="patient-info-container">
    <div class="patient-info-content">
      <h3 class="sidebar-title">Paciente</h3>
      <h6 class="patient-info-title" v-if="patientData">
        {{patientData.first_name}}
        {{patientData.last_name}}
      </h6>
      <div class="row ml-1" v-if="pollData.id">
        <p class="col-6 patient-info-data">
          <span v-if="pollData.sex">{{pollData.sex}}</span>
          <span v-else>Sexo: --</span>
        </p>
        <p class="col-6 patient-info-data">
          <span v-if="pollData.birth">{{getAge(pollData.birth)}}</span>
          <span v-else>Edad: --</span>
        </p>
        <p class="col-6 patient-info-data">
          <span v-if="pollData.height">{{pollData.height}} cms</span>
          <span v-else>Altura: --</span>
        </p>
        <p class="col-6 patient-info-data">
          <span v-if="pollData.weight">{{pollData.weight}} kgs</span>
          <span v-else>Peso: --</span>
        </p>
      </div>
      <div class="row ml-1" v-else>
        <p class="col-6 patient-info-data">
          <span v-if="patientData.sex">{{patientData.sex}}</span>
          <span v-else>Sexo: --</span>
        </p>
        <p class="col-6 patient-info-data">
          <span v-if="patientData.birth">{{getAge(patientData.birth)}}</span>
          <span v-else>Nacido: --</span>
        </p>
        <p class="col-6 patient-info-data">
          <span v-if="patientData.height">{{patientData.height}} cms</span>
          <span v-else>Altura: --</span>
        </p>
        <p class="col-6 patient-info-data">
          <span v-if="patientData.weight">{{patientData.weight}} kgs</span>
          <span v-else>Peso: --</span>
        </p>
      </div>
      <div v-if="pollData.id" class="mt-3">
        <h6 class="patient-info-title">Antecedentes</h6>
        <p class="patient-info-data ml-3">
          Motivación:
          <span v-if="pollData.motivation" >{{pollData.motivation}}</span>
          <span v-else>--</span>
        </p>
        <p v-if="pollData.pregnancy_status" class="patient-info-data ml-3">
          <span>{{pollData.pregnancy_status}}</span>
        </p>
        <p class="patient-info-data ml-3">
          Enfermedades:
          <span v-if="pollData.disease" >{{pollData.disease}}</span>
          <span v-else>--</span>
        </p>
        <p v-if="pollData.disease_detail" class="patient-info-data ml-3">
          Otras enfermedades:
          <span>{{pollData.disease_detail}}</span>
        </p>
        <p class="patient-info-data ml-3">
          Medicación:
          <span v-if="pollData.medication" >{{pollData.medication}}</span>
          <span v-else>--</span>
        </p>
        <p class="patient-info-data ml-3">
          Rutina de trabajo:
          <span v-if="pollData.work_schedule" >{{pollData.work_schedule}}</span>
          <span v-else>--</span>
        </p>
        <p class="patient-info-data ml-3">
          Rutina de sueño:
          <span v-if="pollData.sleep_schedule" >{{pollData.sleep_schedule}}</span>
          <span v-else>--</span>
        </p>
        <p class="patient-info-data ml-3">
          Info extra:
          <span v-if="pollData.extra_personal_info" >{{pollData.extra_personal_info}}</span>
          <span v-else>--</span>
        </p>
        <div v-if="pollData.nutritional_poll" class="mt-3">
          <h6 class="patient-info-title">Información nutricional</h6>
          <p class="patient-info-data ml-3">
            Dieta:
            <span v-if="pollData.nutritional_poll.diet_type">{{pollData.nutritional_poll.diet_type}}</span>
            <span v-else>--</span>
          </p>
          <p class="patient-info-data ml-3">
            Alergias:
            <span v-if="pollData.nutritional_poll.allergies" >{{pollData.nutritional_poll.allergies}}</span>
            <span v-else>--</span>
          </p>
          <p v-if="pollData.nutritional_poll.allergies_detail" class="patient-info-data ml-3">
            Otras alergias:
            <span>{{pollData.nutritional_poll.allergies_detail}}</span>
          </p>
          <p class="patient-info-data ml-3">
            No consume:
            <span v-if="pollData.nutritional_poll.rejected_foods">{{pollData.nutritional_poll.rejected_foods}}</span>
            <span v-else>--</span>
          </p>
          <p v-if="pollData.nutritional_poll.rejected_foods_detail" class="patient-info-data ml-3">
            Tampoco consume:
            <span>{{pollData.nutritional_poll.rejected_foods_detail}}</span>
          </p>
          <p class="patient-info-data ml-3">
            Prefiere:
            <span v-if="pollData.nutritional_poll.junk_food_preference" >{{pollData.nutritional_poll.junk_food_preference}}</span>
            <span v-else>--</span>
          </p>
          <p class="patient-info-data ml-3">
            Síntomas digestivos:
            <span v-if="pollData.nutritional_poll.digestive_symptoms" >{{pollData.nutritional_poll.digestive_symptoms}}</span>
            <span v-else>--</span>
          </p>
          <p class="patient-info-data ml-3">
            Info extra:
            <span v-if="pollData.nutritional_poll.extra_nutritional_info" >{{pollData.nutritional_poll.extra_nutritional_info}}</span>
            <span v-else>--</span>
          </p>
          <p v-if="pollData.nutritional_poll.digestive_symptoms_detail" class="patient-info-data ml-3">
            Otros síntomas:
            <span>{{pollData.nutritional_poll.digestive_symptoms_detail}}</span>
          </p>
          <div v-if="pollData.nutritional_poll.weekly_consumptions" class="mt-3">
            <h6 class="patient-info-title">Tendencia de consumo</h6>
            <p class="patient-info-data ml-3" 
              v-for="(tendency, index) in pollData.nutritional_poll.weekly_consumptions"
              :key="index"
            >
              {{tendency.food}}:
              <span v-if="tendency.trend">{{tendency.trend}}/7</span>
              <span v-else>0/7</span>
            </p>
          </div>
          <div v-if="pollData.nutritional_poll.daily_consumptions" class="mt-3">
            <h6 class="patient-info-title">Comidas diarias</h6>
            <p class="patient-info-data ml-3" 
              v-for="(meal, index) in pollData.nutritional_poll.daily_consumptions"
              :key="index"
            >
              {{meal.meal}} ({{getTime(meal.time)}}):
              <span v-if="meal.details">{{meal.details}}</span>
              <span v-else>--</span>
            </p>
          </div>
        </div>
        <div v-if="pollData.exercise_poll" class="mt-3">
          <h6 class="patient-info-title">Disponibilidad ejercicio</h6>
          <p class="patient-info-data ml-3">
            Días:
            <span v-if="pollData.exercise_poll.days">{{pollData.exercise_poll.days}}</span>
            <span v-else>--</span>
          </p>
          <p class="patient-info-data ml-3">
            Tiempo:
            <span v-if="pollData.exercise_poll.time_per_day">{{pollData.exercise_poll.time_per_day}}</span>
            <span v-else>--</span>
          </p>
          <p class="patient-info-data ml-3">
            Lugar:
            <span v-if="pollData.exercise_poll.place">{{pollData.exercise_poll.place}}</span>
            <span v-else>--</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NutritionalPatientInfo",
  props: {
    patientData: {
      type: Object,
      default: function(){
        return {};
      },
    },
    pollData: {
      type: Object,
      default: function(){
        return {};
      },
    },
  },
  methods: {
    getAge(date) {
      if (this.$moment(date, "YYYY-MM-DD", true).isValid()) {
        return this.$moment().diff(date, 'years') + " años"
      }
      return "Edad: --"
    },
    getTime(time) {
      if (this.$moment(time, ["HH:mm:ss", "HH:mm"]).isValid()) {
        return this.$moment(time, ["HH:mm:ss", "HH:mm"]).format("HH:mm")
      }
      return " "
    },
  }
};
</script>

<style scoped lang="scss">
.patient-info-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.patient-info-content {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;

  & button {
    margin-top: 1rem;
  }
}

.patient-info-button-container {
  padding-top: 1rem;
}

.patient-info-title {
  margin-top: 1.25rem;
  margin-bottom: 0.6rem;
  font-size: $font-size-sm;

  &:first-child {
    margin-top: 0;
  }
}

.patient-info-data {
  padding-top: 0.25rem;
  padding-bottom: 0.1rem;
  margin: 0;
  line-height: 1.2;
  font-size: $font-size-sm;
}

.patient-info-separator {
  margin: 2rem 0;
  height: 0;
  background-color: $gray-300;
}
</style>